var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#474747",
    d: "M1.667 5.417c0-1.768 0-2.652.549-3.201.549-.55 1.433-.55 3.2-.55s2.652 0 3.201.55c.55.549.55 1.433.55 3.2s0 2.652-.55 3.201c-.549.55-1.433.55-3.2.55s-2.652 0-3.201-.55c-.55-.549-.55-1.433-.55-3.2m9.167 9.166c0-1.767 0-2.651.55-3.2.549-.55 1.433-.55 3.2-.55s2.652 0 3.201.55c.55.549.55 1.433.55 3.2s0 2.652-.55 3.201c-.549.55-1.433.55-3.2.55s-2.652 0-3.201-.55c-.55-.549-.55-1.433-.55-3.2m-9.166-.001c0-1.767 0-2.651.549-3.2s1.433-.55 3.2-.55 2.652 0 3.201.55c.55.549.55 1.433.55 3.2s0 2.652-.55 3.201c-.549.55-1.433.55-3.2.55s-2.652 0-3.201-.55c-.55-.549-.55-1.433-.55-3.2m9.167-9.167c0-1.768 0-2.652.55-3.201.549-.55 1.433-.55 3.2-.55s2.652 0 3.201.55c.55.549.55 1.433.55 3.2s0 2.652-.55 3.201c-.549.55-1.433.55-3.2.55s-2.652 0-3.201-.55c-.55-.549-.55-1.433-.55-3.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcon);
export default __webpack_public_path__ + "static/media/servicesIcon.c9d9d40f13438a21734b444cd59eadfb.svg";
export { ForwardRef as ReactComponent };